var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{attrs:{"color":_vm.statoColor}},[_vm._v("mdi-circle")]),_vm._v(" "+_vm._s(_vm.statoLabel)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }